import {RootScope} from '../types/angular-types';

/**
 *
 */
angular.module('GorillaBoy.directives')
.component('didYouKnowMessage', {
    bindings : {
        message : '<',
        messageId : '<'
    },
    template: `
        <div class="dyk-wrapper">            
            <span class="dyk-light-bulb-icon"></span>
            <span ng-bind-html="$ctrl.message" ng-attr-wdcsmkey="{{$ctrl.messageId}}"></span>
        </div>
    `
});
